import type { FaireProductEntity } from "../../entity_types/product";

export const p_hqmqm38k5f: FaireProductEntity = {
  token: "p_hqmqm38k5f",
  type: "product",
  name: "Bubble Merci Note Card",
  brandToken: "b_f12af010",
  brandName: "Banquet Workshop",
  imageUrl:
    "https://cdn.faire.com/fastly/ac0c092c88dbd1d09edba9d990bea1d6800c4a767509a19099f4e95a21315408.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe95c98f308e76a8bc22f9183daf3a1efe91d44de45d5c0f6af9a28935a955bd.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Say thank you the French way! Merci Merci Merci in our own hand drawn bubble type and a graphic true red and blue.  Merci to you!\n\nOffset printed on recycled paper in Canada. \nBlank card measures 4.25 x 5.5 inches and includes A2 envelope.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:32.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
